
import { supabase } from './client';
import { RpcFunctionName, RpcResponse } from './rpc-types';
import { PostgrestError } from '@supabase/supabase-js';

/**
 * A type-safe wrapper for Supabase RPC calls that properly handles custom type definitions
 * This bridges the gap between our custom RPC type definitions and Supabase's generated types
 */
export const typedRpc = {
  /**
   * Make a type-safe RPC call to a function defined in RpcFunctionName
   * 
   * @param fn The RPC function name to call
   * @param params Parameters to pass to the RPC function
   * @returns A promise with the typed response
   */
  async call<F extends RpcFunctionName>(
    fn: F,
    params: Record<string, any> = {}
  ): Promise<{
    data: RpcResponse<F> | null;
    error: PostgrestError | null;
  }> {
    // Use type assertion with 'as any' to bypass TypeScript's type checking
    // This is necessary because Supabase's generated types don't include our custom RPC functions
    const response = await (supabase.rpc as any)(fn, params);
    
    // Then we cast the response to our expected type
    return response as {
      data: RpcResponse<F> | null;
      error: PostgrestError | null;
    };
  }
};
